import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {mutations} from '../../../../api/mutations'
import {removeSettingsQuery} from '../../../common/providers/ApiInterface'
import {ErrorResponse} from '../../../common/types'
import {notifyIfErrorMessage} from '../../../common/utils/errorHandling'

import {invalidateSettingsQuery} from '@settings/modules/common/providers'

export const useDeleteAsset = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()

  return useMutation<void, AxiosError<ErrorResponse>, Parameters<typeof mutations.deleteAsset>[0]>({
    mutationFn: mutations.deleteAsset,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.detail, raiseError, notify)
    },
    onSuccess: (data, variables) => {
      notify('success', t('success.deleteAsset'))
      invalidateSettingsQuery('assets', variables.plantCode)

      removeSettingsQuery('schedule')
    }
  })
}
